import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import { IndexView, ShowView, withBreadCrumbs } from "lego-gui-lib/lib";
import i18next from "i18next";
import { WebUserRoleSchema } from "./schema";
import { CreateView } from "lego-gui-lib";
import { observer } from "mobx-react-lite";

export const WebUserRoles = {
  url: "/webUserRoles",
  handler: (props: RouteComponentProps<any>) => {
    const baseUrl = props.match.url;
    const title = i18next.t("hns:webUserRole:domain_plural");
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("webUserRole", "i18n")(observer(comp));

export const Index = injectDataSource(({ webUserRole, i18n, ...rest }: any) => {
  const title = i18n.t("hns:webUserRole:domain", { count: 2 });
  return (
    <IndexView
      dataSource={webUserRole.listDataSource}
      {...rest}
      title={title}
      columns={WebUserRoleSchema}
    />
  );
});

export const Show = injectDataSource(({ webUserRole, i18n, match }: any) => {
  const title = i18n.t("common:edit", { domain: "hns:webUserRole:domain" });
  const history = useHistory();
  return withBreadCrumbs(
    { to: match.url + "/edit", children: title },
    <ShowView
      dataSource={webUserRole.oneDataSource}
      title={title}
      fields={WebUserRoleSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});

export const Create = injectDataSource(
  ({ webUserRole, i18n, auth, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:webUserRole:domain"
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/create", children: title },
      <CreateView
        dataSource={webUserRole.oneDataSource}
        {...rest}
        title={title}
        fields={WebUserRoleSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);
